import React from 'react'

import { Avatar } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { shape, string } from 'prop-types'

const imageProps = { loading: 'lazy', decoding: 'async' }

function HeroAuthor({ createdByText, author }) {
  return (
    <a href={author.href} className="home-hero__author-badge">
      <span className="home-hero__author-text">{createdByText}</span>
      <Avatar img={author.avatarUrl} username={author.name} size="24" type="color" imageProps={imageProps} />
      <span className="home-hero__author-name">{author.name}</span>
    </a>
  )
}

HeroAuthor.propTypes = {
  createdByText: string.isRequired,
  author: shape({
    name: string,
    href: string,
    avatarUrl: string,
  }).isRequired,
}

export default HeroAuthor
